/**
 * Canvas utility functions for element calculations.
 *
 * Shared utilities used across telemetry and export features.
 */

import { getNonDeletedElements } from "@excalidraw/element";

import type { ExcalidrawElement } from "@excalidraw/element/types";

export interface CanvasBounds {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
}

/**
 * Calculate bounding box of all elements on canvas.
 *
 * @param elements - Array of Excalidraw elements
 * @returns Canvas bounds {minX, minY, maxX, maxY}
 */
export function calculateCanvasBounds(
  elements: readonly ExcalidrawElement[] | readonly any[],
): CanvasBounds {
  const nonDeleted = getNonDeletedElements(elements);

  if (nonDeleted.length === 0) {
    return { minX: 0, minY: 0, maxX: 0, maxY: 0 };
  }

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  nonDeleted.forEach((el: any) => {
    minX = Math.min(minX, el.x);
    minY = Math.min(minY, el.y);
    maxX = Math.max(maxX, el.x + el.width);
    maxY = Math.max(maxY, el.y + el.height);
  });

  return { minX, minY, maxX, maxY };
}
